export enum FreeTextAttributeType {
  HOUSEHOLD_MEASUREMENT = "HouseholdMeasurement",
  MEASUREMENT_AMT_PREPARED = "MeasurementAmtPrepared",
  SERVINGS_PER_CONTAINER = "ServingsPerContainer",
  PORTIONS_PER_CONTAINER = "PortionsPerContainer",
  CAUTIONARY_MESSAGES = "CautionaryMessages",
  ALLERGY_ADVICE = "AllergyAdvice",
  QUANTITATIVE_DECLARATION_OF_INGREDIENTS = "QuantitativeDeclarationOfIngredients",
  NET_QUANTITY = "NetQuantity",
  MANUFACTURER_NAME_AND_ADDRESS = "ManufacturerNameAndAddress",
  COUNTRY_OF_ORIGIN = "CountryOfOrigin",
  PREPARATION_INSTRUCTIONS = "PreparationInstructions",
  STORAGE_INSTRUCTIONS = "StorageInstructions",
  FOOD_ADDITIVES = "FoodAdditives",
  DURABILITY_INDICATION = "DurabilityIndication",
  ALCOHOLIC_STRENGTH_BY_VOLUME = "AlcoholicStrengthByVolume",

  MEDICINAL_INGREDIENTS_HEADER = "MedicinalIngredientsHeader",
  PRODUCT_LICENCE_HOLDER_OR_IMPORTER = "ProductLicenceHolderOrImporter",
  PRODUCT_LICENCE_HOLDER_CONTACT_INFORMATION = "ProductLicenceHolderContactInformation",
  RECOMMENDED_USE_OR_PURPOSE = "RecommendedUseOrPurpose",
  RECOMMENDED_ROUTE_OF_ADMINISTRATION = "RecommendedRouteOfAdministration",
  DOSE = "Dose",
  DURATION_OF_USE = "DurationOfUse",
  WARNINGS = "Warnings",
  CONTAINS_ASPARTAME = "ContainsAspartame",
  DO_NOT_USE = "DoNotUse",
  ASK_HEALTH_CARE_PRACTITIONER = "AskHealthCarePractitioner",
  KNOWN_ADVERSE_REACTIONS = "KnownAdverseReactions",
  DIRECTIONS = "Directions",
  STORAGE_INFORMATION = "StorageInformation",
  QUESTIONS_OR_CONTACT = "QuestionsOrContact",
  LOT_NUMBER = "LotNumber",
  EXPIRY_DATE = "ExpiryDate",
  RISK_INFORMATION = "RiskInformation",
}